<form [formGroup]="filterForm" (ngSubmit)="onSubmit()">
  <ap-label [status]="'DEFAULT'">{{ 'FILTERS.ADD.EQ' | translate }}</ap-label>
  <input formControlName="value" type="date" class="form-control">
  <button [disabled]="!filterForm.valid" class="btn btn-success" type="submit" attr.aria-label="{{ 'FILTERS.ADD.VALID' | translate }}">{{ 'FILTERS.ADD.VALID' | translate }}</button>
</form>